import { render } from "./ProfileSettingsAccountType.vue?vue&type=template&id=2d630dc4&ts=true"
import script from "./ProfileSettingsAccountType.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsAccountType.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__